// import Tab from '@material-ui/core/Tab'
// import { useTheme } from '@material-ui/core/styles'
import { Link } from '@reach/router'
// import { css } from 'helpers'
import { Tabs } from '@xooom/ui'
import React from 'react'

export function TabBasic({
  selected,
  disabled,
  to = '',
  onClick,
  children,
  hide,
  style,
}) {
  // const theme = useTheme()
  if (hide) return null
  return (
    <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
      <Tabs.Trigger value={to} disabled={disabled} style={style}>
        {children}
      </Tabs.Trigger>
    </Link>
  )
}
